import { render, staticRenderFns } from "./Uml3.vue?vue&type=template&id=be92158e&scoped=true&"
import script from "./Uml3.vue?vue&type=script&lang=js&"
export * from "./Uml3.vue?vue&type=script&lang=js&"
import style0 from "./Uml3.vue?vue&type=style&index=0&id=be92158e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be92158e",
  null
  
)

export default component.exports